import axios from 'axios'
import router from "../router";

const request = axios.create({
  // baseURL: 'http://127.0.0.1:8061',
  // baseURL: 'http://120.46.148.201:8080',
  baseURL: '',
  withCredentials: true,
  timeout: 15000,
})

request.interceptors.request.use(
  config => {
    if (config.method == 'post') {
      config.headers['Content-Type'] = 'application/json'
    }
    if (localStorage.getItem('Authorization')) {
      config.headers['deyi-user-token'] = localStorage.getItem('Authorization');
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  })


request.interceptors.response.use( response => {
  return response;
}, error => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        localStorage.removeItem('Authorization')
        localStorage.removeItem('CurrentUser')
        router.push('/login')
    }
  }
  return Promise.reject(error.response.data)
})


export default request



// WEBPACK FOOTER //
// ./src/js/request.js